import { render, staticRenderFns } from "./EmbedAccessDenied.vue?vue&type=template&id=09e3c459&scoped=true&"
import script from "./EmbedAccessDenied.vue?vue&type=script&lang=js&"
export * from "./EmbedAccessDenied.vue?vue&type=script&lang=js&"
import style0 from "./EmbedAccessDenied.vue?vue&type=style&index=0&id=09e3c459&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e3c459",
  null
  
)

export default component.exports